<div fxLayout="row" fxFill>
  @if (resAsync | async) {
    <div fxFlex="40px" fxShow="{{ renderHignaButtons }}" class="sidebar">
      <mat-button-toggle
        (change)="filterByContextObjects(isFilteredByContextObjects)"
        [checked]="isFilteredByContextObjects"
        [disabled]="!canFilterByContextObjects()"
      >
        <mat-icon [svgIcon]="res.svgName('Filter-Image')"></mat-icon>
      </mat-button-toggle>
      <mat-button-toggle (change)="shareCurrentObject(isSharingCurrentObject)" [checked]="isSharingCurrentObject">
        <mat-icon [svgIcon]="res.svgName('Navigate-Image')"></mat-icon>
      </mat-button-toggle>
      <button mat-icon-button (click)="shareCurrentObjects()">
        <mat-icon [svgIcon]="res.svgName('Share-Image')"></mat-icon>
      </button>
    </div>
  }
  <abc-grid
    #abcGridContainer
    (onEditorPreparing)="onEditorPreparing($event)"
    [setupDefaultLayoutOnInitialization]="true"
    [rowAlternationEnabled]="true"
    [focusedRowEnabled]="true"
    [autoNavigateToFocusedRow]="true"
    [autoFilterSelectedRows]="true"
    [rtlEnabled]="rtlEnabled"
    keyExpr="Id"
    [selection]="{ mode: 'single' }"
    (onAIColumnRequestCreating)="handleAIColumnRequestCreating($event)"
  >
  </abc-grid>
</div>
<div #objectsSets></div>
